import { FlatTreeElement } from '../models/flatTreeElement.model';

// Function that gets a flat node's level
export function getNodeLevel({ level }: FlatTreeElement) {
  return level;
}
